import GS from '../../grafsync/grafsync';
import MoodIcon from '@material-ui/icons/Mood';
import MoodBadIcon from '@material-ui/icons/MoodBad';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { ENTITLEMENTS } from '../../application-core/constants';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import AssignUserDialog from './AssignUserDialog';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { SUGGESTION_TYPE_OPTIONS } from '../../vocabulary/constants';
import { Typography } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import BasicReadField from '../../core/BasicReadField';
import IriDisplay from '../../vocabulary/taxonomies/IriDisplay';
import LangConfirmationField from '../LangConfirmationField';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';
import { STATUS_ACCEPTED, STATUS_PENDING, STATUS_REJECTED } from '../utils/constants';

const APPROVED = STATUS_ACCEPTED;
const PENDING = STATUS_PENDING;
const REJECTED = STATUS_REJECTED;

class SuggestionDisplay extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showAssignUserDialog: false,
      disabled: false
    };
  }

  assignUser = (user) => {
    if (user === "All") user = undefined;
    this.setState({ showAssignUserDialog: false, user });
    if (!(this.props.data.assignedUser === undefined && user === undefined)) {
      this.props.data.assignedUser !== undefined ?
        user === undefined ?
          this.props.onDelete('assignedUser', this.props.data.assignedUser)
          :
          this.props.onUpdate('assignedUser', user)
        :
        this.props.onAdd('assignedUser', user);
    }
    this.props.onChange();
  };

  showAssignUser = () => this.setState({ showAssignUserDialog: true });

  cancelAssignUser = () => this.setState({ showAssignUserDialog: false });

  // We need to bubble up from the concept data in certain updates
  monitorLinkUpdate = (iri) => {
    const data = GS.data(iri, this.props.graph, false);
    let disabled = false;
    if (!data.inScheme || data.inScheme.length === 0 || data.deprecated === true || data.pendingDeletion === true) {
      disabled = true;
    }
    this.setState({
      disabled,
      ...(disabled) && { showAssignUserDialog: false }
    });
  };

  render() {

    const { data, classes, project, taxonomies, graph, defaultLang, entitlements, projectUsers, user, assignedFilter, viewLang } = this.props;
    const { inScheme, comment, status, suggestionSourceConcept, prefLabel, assignedUser } = data;
    const { showAssignUserDialog, disabled } = this.state;

    const isDeleted = data.pendingDeletion;
    const prefLabelLang = prefLabel ? Object.keys(prefLabel)[0] : null;
    const suggestionType = SUGGESTION_TYPE_OPTIONS.find(option => option.value === data.type);
    const title = suggestionType.label;
    const foundUser = projectUsers.find(pu => pu.value === assignedUser);
    const assigned = foundUser ?
      foundUser.label
      :
      "User not available";
    const usedStatus = status ?
      Array.isArray(status) ?
        status[0]
        :
        status
      :
      null;

    const statusText = usedStatus ?
      usedStatus === PENDING ?
        "Pending"
        :
        usedStatus === APPROVED ?
          "Accepted"
          :
          "Rejected"
      :
      "Uncategorised";

    const canEdit = usedStatus !== APPROVED && usedStatus !== REJECTED && !disabled;

    return (
      <TableRow
        data-test={"suggestion-" + data.id}
        classes={{
          root: classes.stripedRow
        }}
        style={{ ...(isDeleted) && { backgroundColor: '#DD2C00' } }}>
        <TableCell data-test="resource" component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 2 }}>
            {suggestionSourceConcept &&
              <IriDisplay
                id={suggestionSourceConcept}
                updateEvent={this.monitorLinkUpdate}
                deleteEvent={this.monitorLinkUpdate}    
                compact={true}
                components={taxonomies}
                projectIRI={project}
                handleNotAvailable={true}
                graph={graph}
                viewLang={viewLang}
                defaultLang={defaultLang} />
            }
          </div>
        </TableCell>
        <TableCell data-test="component" component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 2 }}>
            <IriDisplay
              id={Array.isArray(inScheme) ? inScheme[0] : inScheme}
              compact={true}
              components={taxonomies}
              projectIRI={project}
              handleNotAvailable={true}
              graph={graph}
              viewLang={viewLang}
              defaultLang={defaultLang} />
          </div>
        </TableCell>
        <TableCell component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 4 }}>
            <Chip
              data-test="status"
              color="primary"
              avatar={
                <Avatar style={{ backgroundColor: 'inherit' }}>
                  {usedStatus === PENDING &&
                    <NewReleasesIcon fontSize="small" />
                  }
                  {usedStatus === APPROVED &&
                    <MoodIcon fontSize="small" />
                  }
                  {usedStatus === REJECTED &&
                    <MoodBadIcon data-test="rejected-icon" fontSize="small" />
                  }
                </Avatar>
              }
              clickable={false}
              label={statusText}
              className={classes.statusChip}
            />
          </div>
        </TableCell>
        <TableCell data-test={"suggestion-title"} component="td" className={classes.tableCell}>
          <Typography variant="body2" style={{ marginTop: 6 }}>{title}</Typography>
        </TableCell>
        <TableCell data-test={"suggestion-label"} component="td" className={classes.tableCell}>
          {prefLabel &&
            <BasicReadField lang={prefLabelLang} dataTest="suggested-label" fullWidth text={prefLabel[prefLabelLang]} />
          }
        </TableCell>
        <TableCell component="td" className={classes.tableCell} align='left'>
          <div style={{ paddingTop: 4 }}>
            {assignedUser &&
              <Chip
                data-test="assignee"
                color="secondary"
                avatar={
                  <Avatar style={{ backgroundColor: 'inherit' }}>
                    <AssignmentIndIcon fontSize="small" />
                  </Avatar>
                }
                clickable={false}
                label={assigned}
                className={classes.statusChip}
              />
            }
          </div>
        </TableCell>
        <TableCell component="td" className={classes.tableCell}>
          {comment && Object.keys(comment).length > 0 &&
            <LangConfirmationField
              dataTest="suggestion-detail"
              focus={false}
              canBeDeleted={false}
              multiline={true}
              text={comment[Object.keys(comment)[0]]}
              lang={Object.keys(comment)[0]}
              isReadOnly={true} />
          }
        </TableCell>
        <TableCell component="td" className={classes.tableCell} align='right'>
          <div style={{ paddingTop: 4, marginRight: 12 }}>
            {canEdit && (entitlements.includes(ENTITLEMENTS.MANAGE_SUGGESTIONS) || entitlements.includes(ENTITLEMENTS.MANAGE_SUGGESTIONS))
              && (assignedFilter === "UNASSIGNED" || assignedUser === user) && status && status[0] === PENDING &&
              <Tooltip placement="right" title='Assign'>
                <IconButton data-test="assign" size="small" onClick={this.showAssignUser}>
                  <PersonIcon />
                </IconButton>
              </Tooltip>
            }
            {canEdit && showAssignUserDialog &&
              <AssignUserDialog
                onAssignUser={this.assignUser}
                allowInstructions={false}
                exclude={assignedUser || "All"}
                defaultLang={defaultLang}
                projectUsers={projectUsers}
                onCancel={this.cancelAssignUser}
              />
            }
          </div>
        </TableCell>
      </TableRow>
    );
  }
}

SuggestionDisplay.propTypes = {
  classes: PropTypes.object,
  taxonomies: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  graph: PropTypes.string.isRequired,
  entitlements: PropTypes.array,
  project: PropTypes.string.isRequired,
  projectUsers: PropTypes.array.isRequired,
  viewLang: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(SuggestionDisplay, ["ALL"], null, {}, true));